import Glide from '@glidejs/glide';

export const Carousel = (function () {
	'use strict';

	let carousels;

	function init() {
		carousels = document.querySelectorAll('.glide');
		if (carousels && carousels.length > 0) {
			carousels.forEach(function (el) {
				renderCarousel(el);
			});
		}
	}

	function renderCarousel(carousel) {
		new Glide(carousel, {
			type: 'carousel',
			autoplay: 3000,
		})
			.on(['run.after'], function (whatIsThis) {
				let $c = $(carousel);
				let $active = $c.find('.glide__slide--active');
				let $calloutTitle = $('.callout__title-section');

				if ($active.hasClass('glide__slide--no-noms')) {
					$calloutTitle.slideUp(); // hide fadeOut
				} else {
					$calloutTitle.slideDown(); // show fadeIn
				}
			})
			.mount();
	}

	return {
		init: init,
	};
})();
